var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2753 4.22736C12.4238 5.23499 11.0614 6.02973 9.69896 5.9162C9.52865 4.55377 10.1957 3.1062 10.9762 2.21211C11.8277 1.1761 13.3179 0.438115 14.5242 0.381348C14.6661 1.80054 14.1126 3.19135 13.2753 4.22736ZM14.51 6.18585C12.5373 6.07231 10.8485 7.30701 9.91183 7.30701C8.96098 7.30701 7.52759 6.24261 5.96648 6.271C3.93703 6.29938 2.04951 7.44893 1.01349 9.27969C-1.11529 12.9412 0.46001 18.3625 2.51784 21.3428C3.52547 22.8188 4.73178 24.4367 6.32128 24.3799C7.82562 24.3231 8.42168 23.4007 10.2382 23.4007C12.069 23.4007 12.5941 24.3799 14.1836 24.3515C15.8299 24.3231 16.8659 22.8756 17.8735 21.3996C19.0231 19.7249 19.4914 18.0929 19.5198 18.0077C19.4914 17.9793 16.3408 16.773 16.3124 13.1399C16.284 10.1028 18.796 8.65524 18.9095 8.57009C17.4903 6.46968 15.2764 6.24261 14.51 6.18585Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.b2199bc3.svg";
export { ForwardRef as ReactComponent };